import React from "react";
import classNames from "classnames";
import styles from "./ForecastDataGrid.module.scss";
import { get15MinIntervalsForDate } from "helpers/timeIntervals";

import { grey } from "@mui/material/colors";
import { formatNumberByThousands } from "helpers/numbers";

const ProductionForecastFixedTable = ({ totalForecast, forecastDate }) => {
  const periods = get15MinIntervalsForDate(forecastDate);

  return (
    <div className={classNames(styles.forecastDataGrid, styles.fixedTable)}>
      <table
        className={classNames(styles.table, styles.fixedTable)}
        style={{
          border: "solid",
          borderWidth: 1,
          borderTop: 0,
          borderBottom: 0,
          borderLeft: 0,
          borderColor: grey[400],
        }}
      >
        <thead>
          <tr style={{ background: grey[200] }}>
            <th>
              <div
                style={{
                  minHeight: "34px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                Summary
              </div>
            </th>
            <th></th>
          </tr>
          <tr>
            <th>Period</th>
            <th>Forecast</th>
          </tr>
          <tr>
            <th>&nbsp;</th>
            <th>&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          {periods.map((period, rowIndex) => (
            <tr key={rowIndex}>
              <td className={styles.period}>
                <span className={styles.cellContent}>{period}</span>
              </td>
              <td className={styles.period}>
                <span
                  className={classNames(
                    styles.cellContent,
                    styles.totalForecast,
                  )}
                >
                  {totalForecast[rowIndex]
                    ? formatNumberByThousands(
                        Math.round(totalForecast[rowIndex]),
                      )
                    : 0}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ProductionForecastFixedTable;
